import { NotificationCard, Section } from "@arp/react-ndbx";
import { Box, Fade, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { Application } from "../../../config/const/enums";
import { reviewApplicationDisclaimer } from "../../../config/disclaimers/disclaimers";

function ReviewApplicationDOD({ personOne, application }) {
  const StyledDodSection = styled((props) => (
    <Section mb={{ xs: 2, md: 3 }} sx={{ textAlign: "left" }} {...props} />
  ))(({}) => ({}));

  const StyledDodHeadSection = styled((props) => (
    <Section mb={{ xs: 2, md: 3 }} {...props} />
  ))(({}) => ({}));

  const isCC = application === Application.CONTACT_CENTER;

  return (
    <Section md={7} mb={{ xs: 3, md: 4 }}>
      <StyledDodHeadSection>
        <Typography variant="label-large-bold">
          {personOne.firstName}, double check your application details.
        </Typography>
      </StyledDodHeadSection>
      <StyledDodSection>
        <Typography variant="p3">
          {isCC
            ? reviewApplicationDisclaimer().REVIEW_ANSWER_CC
            : reviewApplicationDisclaimer().REVIEW_ANSWER}
        </Typography>
      </StyledDodSection>
      <StyledDodSection>
        <Typography variant="p3">
          {isCC
            ? reviewApplicationDisclaimer().DUTY_CARE_CC
            : reviewApplicationDisclaimer().DUTY_CARE}
        </Typography>
      </StyledDodSection>
      <StyledDodSection>
        <Typography variant="p3">
          {isCC
            ? reviewApplicationDisclaimer().RECORD_OF_ANSWERS_CC
            : reviewApplicationDisclaimer().UPDATE_INFO}
        </Typography>
      </StyledDodSection>

      <StyledDodSection>
        <Typography variant="p3">
          {isCC
            ? reviewApplicationDisclaimer().UPDATE_INFO_CC
            : reviewApplicationDisclaimer().RECORD_OF_ANSWERS}
        </Typography>
      </StyledDodSection>
      <StyledDodHeadSection>
        <Typography variant="label-large-bold">
          {reviewApplicationDisclaimer().PDS}
        </Typography>
      </StyledDodHeadSection>
    </Section>
  );
}

export default ReviewApplicationDOD;
